import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import VisuallyHidden from 'components/consumer/VisuallyHidden';
import { PDP_READYTOSHIP_TAB_ID } from 'commons/constants';
import ToggleButton from './ToggleButton';

const ToggleButtonGroup = ({
  'aria-label': ariaLabel,
  className = '',
  items,
  selectedItem,
  size = 'sm',
  styling,
}) => (
  <>
    <VisuallyHidden>
      Clicking on one of the following buttons will update the content below.
    </VisuallyHidden>

    <div
      aria-label={ariaLabel}
      className={classNames(`flex flex-row list-none m-0 ${className}`, {
        'gap-[15px]': styling === 'ImportantToggle',
      })}
      role="tablist"
    >
      {items.map(
        ({
          contentId,
          id,
          label,
          description,
          isSelected,
          onClick,
          infoTooltip = false,
          infoTooltipContent = '',
        }) => (
          <ToggleButton
            styling={styling}
            contentId={contentId}
            id={id}
            showCloseButton={id !== PDP_READYTOSHIP_TAB_ID}
            iconSize={id === PDP_READYTOSHIP_TAB_ID ? 'big' : 'small'}
            isSelected={isSelected || selectedItem === id}
            key={id}
            label={label}
            description={description}
            onClick={onClick}
            size={size}
            infoTooltip={infoTooltip}
            infoTooltipContent={infoTooltipContent}
          />
        )
      )}
    </div>
  </>
);

ToggleButtonGroup.propTypes = {
  'aria-label': PropTypes.string.isRequired,
  className: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      contentId: PropTypes.string.isRequired,
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      description: PropTypes.string,
      isSelected: PropTypes.bool,
      onClick: PropTypes.func,
      infoTooltip: PropTypes.bool,
      infoTooltipContent: PropTypes.string,
    })
  ).isRequired,
  selectedItem: PropTypes.string,
  size: PropTypes.oneOf(['xs', 'sm']),
  styling: PropTypes.oneOf(['ImportantToggle']),
};

export default ToggleButtonGroup;
